<template>
  <ArtisanGrid ref="limit" metaKey="BasisReserveLimit">
    <template #patientAge="{ row }">
      <span>{{ calcAge(row.patientBirthday) }}</span>
    </template>
    <template #patientPhone="{ row }">
      <span>{{ keepSecret(row.patientPhone) }}</span>
    </template>
  </ArtisanGrid>
</template>

<script>
import moment from "moment";
export default {
  methods: {
    calcAge(birthday) {
      return moment().year() - moment(birthday).year();
    },
    keepSecret(phone) {
      let end = phone.length - 4;
      let start = 3;
      let str = phone.substring(0, start);
      for (let index = start; index < end; index++) {
        str += "*";
      }
      str += phone.substring(end);
      return str;
    },
  },
};
</script>

<style></style>